import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexDropzone',
  setup(__props) {

const defaultDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/defaultDropzone.vue"))
const imageDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/imageDropzone.vue"))
const singleDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/singleDropzone.vue"))
const multiDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/multiDropzone.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      title: "Dropzone"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(defaultDropzone)),
        _createVNode(_unref(imageDropzone)),
        _createVNode(_unref(singleDropzone)),
        _createVNode(_unref(multiDropzone))
      ])
    ])
  ], 64))
}
}

})